import styled from 'styled-components';
import { COLORS } from '../../styles/variables';

export const NoOffersSection = styled.section<{ isNoFilteredOffers?: boolean }>`
  background-color: ${COLORS.grey5};
  width: 100%;
  height: ${({ isNoFilteredOffers }) => (isNoFilteredOffers ? '50vh' : '100vh')};
  overflow-y: unset;
  flex: 1;
  position: relative;
`;
export const NoOffersWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0 42px;
`;
export const NoOffersTitle = styled.h1`
  font-size: 32px;
  line-height: 48px;
  padding-bottom: 24px;
  letter-spacing: 0.003px;
`;
export const NoOfferText = styled.p`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
`;
export const Ctas = styled.div`
  min-width: 380px;
  padding-top: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
export const Cta = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: inherit;
  width: 240px;
  border: 1px solid black;
  background-color: transparent;
  padding: 16px 32px;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.003px;
  cursor: pointer;
`;
